export const texts = {
  candidates: {
    de: 'Kandidat:innen',
    en: 'Candidates'
  },
  batchesAll: {
    de: 'Batches: Alle',
    en: 'Batches: All'
  },
  batch: {
    de: 'Batch',
    en: 'Batch'
  },
  all: {
    de: 'Alle',
    en: 'All'
  },
  statusAll: {
    de: 'Status: Alle',
    en: 'Status: All'
  },
  undecided: {
    de: 'Unentschieden',
    en: 'Undecided'
  },
  accepted: {
    de: 'Ausgewählt',
    en: 'Selected'
  },
  rejected: {
    de: 'Abgelehnt',
    en: 'Rejected'
  },
  noCandidates: {
    de: 'Starte das Projekt, um Bewerbungen zu erhalten.',
    en: 'No applicants yet'
  },
  applicants: {
    de: 'Bewerber',
    en: 'Applicants'
  },
  noApplicants: {
    de: 'Es liegen noch keine Bewerber:innen vor',
    en: 'There are no applicants yet'
  },
  groups: {
    shortlisted: {
      de: 'Vorgestellt',
      en: 'Presented'
    },
    shortlistedNonCommittal: {
      de: 'Vorgestellt (unverbindlich)',
      en: 'Presented (non-committal)'
    },
    inSelection: {
      de: 'In der Auswahl',
      en: 'In selection'
    },
    hired: {
      de: 'Eingestellt',
      en: 'Hired'
    },
    notHired: {
      de: 'Keine Einstellung',
      en: 'Not hired'
    }
  },
  talents: {
    de: 'Referenzprofile',
    en: 'Reference profiles'
  },
  talentsBodyAfter: {
    de: 'Die Talente sind bereits zur Ansprache vorbereitet. Erste Rückmeldungen sind schon ab 24 Stunden zu erwarten.',
    en: 'The talents are already prepared for outreach. First responses can be expected within 24 hours.'
  },
  perfectMatchBadge: {
    de: 'Perfect Match',
    en: 'Perfect Match'
  },
  reviewCta: {
    de: 'Talente prüfen',
    en: 'Review talents'
  },
  reviewTitle: {
    de: 'Talente prüfen',
    en: 'Review talents'
  },
  reviewQuestion: {
    de: 'Passt das Profil?',
    en: 'Is this profile a fit?'
  },
  thumbsUp: {
    de: 'Passt',
    en: 'Good fit'
  },
  thumbsDown: {
    de: 'Passt nicht',
    en: 'Not a fit'
  },
  reviewComment: {
    de: 'Kommentar (optional)',
    en: 'Comment (optional)'
  },
  back: {
    de: 'Zurück',
    en: 'Back'
  },
  next: {
    de: 'Weiter',
    en: 'Next'
  },
  reviewDone: {
    de: 'Fertig',
    en: 'Done'
  },
  experienceTitle: {
    de: 'Berufserfahrung',
    en: 'Work experience'
  },
  educationTitle: {
    de: 'Berufsausbildung',
    en: 'Education'
  },
  noInformation: {
    de: 'Es liegen keine Angaben vor',
    en: 'No information available'
  },
  present: {
    de: 'heute',
    en: 'present'
  },
  noApplicantsHeadline: {
    de: 'Noch keine Bewerbungen',
    en: 'No applicants yet'
  },
  noApplicantsBody: {
    de: 'Sobald sich Talente auf die Stelle bewerben, findest du sie hier.',
    en: 'As soon as talents apply for this position you will find them here.'
  }
};
